<template>
  <DataTable
    :value="list"
    paginator
    :rows="5"
    :rowsPerPageOptions="[5, 10, 20, 50]"
    tableStyle="min-width: 50rem"
    :loading="loadingRequisites"
  >
    <Column field="index" header="#" style="width: 3%">
      <template #body="{ index }">
        {{ index + 1 }}
      </template>
    </Column>
    <Column field="codigo_rude" header="RUDE" style="width: 15%"></Column>
    <Column field="paterno" header="PATERNO" style="width: 12%"></Column>
    <Column field="materno" header="MATERNO" style="width: 12%"></Column>
    <Column field="nombre" header="NOMBRE" style="width: 15%"></Column>
    <Column
      field="carnet_identidad"
      header="CARNET"
      style="width: 10%"
    ></Column>
    <Column
      field="fecha_nacimiento"
      header="FECHA NACIMIENTO"
      style="width: 12%"
    >
      <template #body="{ data }">
        {{ formatDate(data.fecha_nacimiento) }}
      </template>
    </Column>
    <Column
      field="area"
      header="ÁREA DE PARTICIPACIÓN"
      style="width: 15%"
    ></Column>
    <Column header="ACCIONES" style="width: 10%">
      <template #body="{ data }">
        <div class="flex gap-2 align-items-center">
          <div v-if="!statusEnrollment">
            <Button
              icon="pi pi-trash"
              severity="danger"
              text
              rounded
              @click="confirmDelete(data.id)"
              :pt="{ root: { class: 'p-1' } }"
              aria-label="Eliminar estudiante"
            />
          </div>
          <Button
            severity="info"
            @click="showRequisitePopup($event, data.id)"
            :disabled="loadingRequisites"
            class="requisite-button p-1"
            rounded
            text
            aria-label="Ver requisitos"
          >
            <i class="pi pi-search"></i>
            <ProgressSpinner
              v-if="loadingRequisites && currentCompetitorId === data.id"
              style="width: 20px; height: 20px"
              strokeWidth="6"
              animationDuration=".5s"
            />
          </Button>
          <Menu
            ref="requisiteMenu"
            :model="requisiteItems"
            :popup="true"
            id="overlay_menu"
          />
        </div>
      </template>
    </Column>
  </DataTable>

  <Dialog
    v-model:visible="fileDialogVisible"
    :header="
      selectedRequisite?.requisite_catalog?.description || 'Documentos Adjuntos'
    "
    :style="{ width: '50vw', maxWidth: '800px' }"
    :modal="true"
    :closable="!filesLoading"
  >
    <div v-if="selectedRequisite">
      <div v-if="filesLoading" class="flex justify-content-center py-4">
        <ProgressSpinner />
      </div>
      <DataTable
        v-else
        :value="files"
        :loading="filesLoading"
        :paginator="files.length > 5"
        :rows="5"
        :rowsPerPageOptions="[5, 10, 20]"
        stripedRows
      >
        <Column field="name" header="Nombre del Archivo">
          <template #body="{ data }">
            <span class="truncate-text" :title="data.name">{{
              data.name
            }}</span>
          </template>
        </Column>
        <Column header="Acciones" style="width: 30%">
          <template #body="{ data }">
            <Button
              icon="pi pi-download"
              label="Descargar"
              severity="info"
              @click="downloadFile(data.id)"
              :loading="downloadingFile === data.id"
              size="small"
            />
          </template>
        </Column>
        <template #empty>
          <div class="text-center py-4">
            No se encontraron archivos para este requisito
          </div>
        </template>
      </DataTable>
    </div>
    <template #footer>
      <Button
        label="Cerrar"
        icon="pi pi-times"
        @click="fileDialogVisible = false"
        severity="secondary"
      />
    </template>
  </Dialog>
</template>

<script setup>
import { ref, computed, nextTick } from "vue";
import axios from "@/includes/connection";
import Swal from "sweetalert2";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";
import Menu from "primevue/menu";
import Dialog from "primevue/dialog";

const props = defineProps({
  students: Array,
  statusEnrollment: Boolean,
  participantSelected: Array,
});

const emit = defineEmits(["toggleParticipant", "student-deleted"]);

// Refs
const requisiteMenu = ref();
const fileDialogVisible = ref(false);
const selectedRequisite = ref(null);
const files = ref([]);
const filesLoading = ref(false);
const downloadingFile = ref(null);
const loadingRequisites = ref(false);
const currentCompetitorId = ref(null);
const requisiteItems = ref([]);
const listRequires = ref([]);

// Computed
const list = computed(() => props.students || []);

// Methods
const showRequisitePopup = async (event, competitorId) => {
  try {
    loadingRequisites.value = true;
    currentCompetitorId.value = competitorId;
    requisiteItems.value = []; // Clear previous items

    // requisiteItems.value = [
    //   {
    //     items: [
    //       {
    //         label: "Refresh",
    //         icon: "pi pi-refresh",
    //       },
    //       {
    //         label: "Export",
    //         icon: "pi pi-upload",
    //       },
    //     ],
    //   },
    // ];

    const response = await axios.post("/institution/get-info-by-competitor", {
      competitorId: competitorId,
    });

    listRequires.value = response.data;
    const listItems = listRequires.value.competitorRequisites.map((item) => ({
      label: item.requisite_catalog?.description || "Sin descripción",
      command: () => showFilesDialog(item),
      icon: "pi pi-file",
      disabled: item.filesCount === 0, // Assuming you might add this property
    }));

    requisiteItems.value = [{ items: listItems }];

    console.log("option :: ", requisiteItems.value);

    requisiteMenu.value.toggle(event);

    // await nextTick();
    // console.log("competitorId", competitorId);

    // if (requisiteMenu.value?.toggle) {
    //   requisiteMenu.value.toggle(event);
    // } else {
    //   openFallbackDialog();
    // }
  } catch (error) {
    console.error("Error loading requisites:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo cargar la información de requisitos",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
    openFallbackDialog();
  } finally {
    loadingRequisites.value = false;
  }
};

// const showRequisitePopup = (event, demo) => {
//   requisiteMenu.value.toggle(event);
// };

const openFallbackDialog = () => {
  fileDialogVisible.value = true;
  selectedRequisite.value = {
    requisite_catalog: { description: "Todos los requisitos" },
    id: currentCompetitorId.value,
  };
  loadAllFiles();
};

const loadAllFiles = async () => {
  try {
    filesLoading.value = true;
    const response = await axios.get("/institution/get-files", {
      params: {
        competitorId: currentCompetitorId.value,
      },
    });
    files.value = response.data;
  } catch (error) {
    console.error("Error loading all files:", error);
    files.value = [];
  } finally {
    filesLoading.value = false;
  }
};

const showFilesDialog = async (requisite) => {
  try {
    selectedRequisite.value = requisite;
    filesLoading.value = true;
    fileDialogVisible.value = true;
    files.value = [];

    const response = await axios.get("/institution/get-files", {
      params: {
        competitorId: currentCompetitorId.value,
        requisiteId: requisite.id,
      },
    });

    files.value = response.data;
  } catch (error) {
    console.error("Error loading files:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Error al cargar los archivos",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
  } finally {
    filesLoading.value = false;
  }
};

const downloadFile = async (fileId) => {
  try {
    downloadingFile.value = fileId;
    const response = await axios({
      url: `/institution/download-file/${fileId}`,
      method: "GET",
      responseType: "blob",
    });

    const contentDisposition = response.headers["content-disposition"];
    const fileNameMatch = contentDisposition?.match(/filename="?(.+)"?/);
    const fileName = fileNameMatch?.[1] || `documento_${fileId}`;

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);

    Swal.fire({
      icon: "success",
      title: "Descarga iniciada",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
  } catch (error) {
    console.error("Error downloading file:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo descargar el archivo",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
  } finally {
    downloadingFile.value = null;
  }
};

const formatDate = (dateString) => {
  if (!dateString) return "";

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    return date.toLocaleDateString("es-BO", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return dateString;
  }
};

const confirmDelete = (studentId) => {
  Swal.fire({
    title: "¿Estás seguro?",
    text: "¡Esta acción no se puede deshacer!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sí, eliminar",
    cancelButtonText: "Cancelar",
    focusCancel: true,
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      deleteStudent(studentId);
    }
  });
};

const deleteStudent = async (id) => {
  try {
    await axios.post("/institution/removed-student", { studentId: id });
    emit("student-deleted", id);
    Swal.fire({
      icon: "success",
      title: "¡Eliminado!",
      text: "El estudiante ha sido eliminado",
      timer: 2000,
      showConfirmButton: false,
    });
  } catch (error) {
    console.error("Error deleting student:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo eliminar el estudiante",
      timer: 2000,
      showConfirmButton: false,
    });
  }
};
</script>

<style scoped>
.flex {
  display: flex;
}

.gap-2 {
  gap: 0.5rem;
}

.align-items-center {
  align-items: center;
}

.justify-content-center {
  justify-content: center;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.text-center {
  text-align: center;
}

.truncate-text {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.requisite-button {
  position: relative;
  min-width: 2rem;
}

/* Improved button hover effects */
.p-button.p-button-text:not(:disabled):hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Better spacing for action buttons */
.actions-column {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
</style>
